import { render, staticRenderFns } from "./VideoVue.vue?vue&type=template&id=5d1a6a78&scoped=true"
import script from "./VideoVue.vue?vue&type=script&lang=js"
export * from "./VideoVue.vue?vue&type=script&lang=js"
import style0 from "./VideoVue.vue?vue&type=style&index=0&id=5d1a6a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a6a78",
  null
  
)

export default component.exports